// React Components
import React from 'react';

// Ant Design Components
import { Menu, notification, Popconfirm } from 'antd';

// Utilities & Helpers
import Constants from '../../../../../../apis/constants';
import { v4 as uuidv4 } from 'uuid';

// UI Components
import H3Text from '../../../../../../uilib/h3Text';

// Images
import Crown from '@Images/crown2.png';

const dropDownMenu = ({
  user, selectedGRN, downloadDocument, isLabelAvailable, setIsGenerateLabelModalOpen,
}) => {
  const enableLabelGeneration = user?.tenant_info?.global_config?.sub_modules?.label_generation?.is_active;
  const menu = (
    <Menu>
      {selectedGRN?.org_currency_info?.org_currency_id && (
        <Menu.Item>
          <H3Text
            text={`Download GRN (${selectedGRN?.org_currency_info?.currency_code})`}
            onClick={() => {
              downloadDocument({
                url: `${Constants.GRN}/download?grn_id=${selectedGRN?.grn_id}&tenant_id=${selectedGRN?.tenant_info?.tenant_id}&download_document_in_base_currency=false`,
                document_type: 'GOODS_RECEIVING_NOTE',
                document_number: selectedGRN?.grn_number,
                key: uuidv4(),
              });
            }}
            className="hide__in-mobile"
          />
        </Menu.Item>
      )}
      {(selectedGRN?.base_currency_info?.org_currency_id && selectedGRN?.org_currency_info?.org_currency_id !== selectedGRN?.base_currency_info?.org_currency_id) && (
        <Menu.Item>
          <H3Text
            text={`Download GRN (${selectedGRN?.base_currency_info?.currency_code})`}
            onClick={() => {
              downloadDocument({
                url: `${Constants.GRN}/download?grn_id=${selectedGRN?.grn_id}&tenant_id=${selectedGRN?.tenant_info?.tenant_id}&download_document_in_base_currency=true`,
                document_type: 'GOODS_RECEIVING_NOTE',
                document_number: selectedGRN?.grn_number,
                key: uuidv4(),
              });
            }}
            className="hide__in-mobile"
          />
        </Menu.Item>
      )}
      <Menu.Item>
        <div style={{ display: `${enableLabelGeneration ? 'block' : 'flex'}`, alignItems: 'center' }}>
          <H3Text
            text="Generate Labels"
            onClick={() => {
              if (enableLabelGeneration) {
                if (isLabelAvailable) {
                  setIsGenerateLabelModalOpen(true);
                } else {
                  notification.open({
                    type: 'error',
                    message: 'No Label format is available for Goods Receiving Note to download',
                    duration: 4,
                    placement: 'top',
                  });
                }
              }
            }}
            className="hide__in-mobile"
          />
          {!enableLabelGeneration
            && (
              <Popconfirm
                placement="topRight"
                title="This feature is not accessible within your current plan to use this feature contact us."
                onConfirm={() => globalThis.Intercom('showNewMessage')}
                okText="Contact Us"
                cancelText="Cancel"
              >
                <img
                  className="barcode-restrict"
                  src={Crown}
                  alt="premium"
                  style={{
                    marginLeft: '8px',
                  }}
                />
              </Popconfirm>
            )}
        </div>
      </Menu.Item>
    </Menu>
  );

  return menu;
};

export default dropDownMenu;